import React from 'react';
import styled from 'styled-components';
import {
  ExperienceApprovalStatus,
  ExperienceStatus,
} from '@/webapi/use-experience-api';
import { breakpoints } from '@/components/responsive';

export function DotLabel({
  children,
  dotColor,
  textColor,
  noDot,
}: {
  children?: any;
  noDot?: boolean;
  dotColor?: string;
  textColor?: string;
}) {
  return (
    <ExperienceDate textColor={textColor}>
      {!noDot ? <Dot color={dotColor} /> : null}
      {children}
    </ExperienceDate>
  );
}

const ExperienceDate = styled.span`
  display: flex;
  flex-direction: row;
  align-items: center;

  font-size: 1.2rem;
  color: ${(props: { textColor: string }) =>
    props.textColor ? props.textColor : `#89959c`};
  font-family: Inter, serif;

  ${breakpoints.down(`md`)} {
    font-size: 1rem;
    letter-spacing: -0.3px;
  }
`;

const Dot = styled.span`
  height: 1rem;
  width: 1rem;
  margin-right: 1rem;
  background-color: ${(props: { color: string }) => props.color};
  border-radius: 50%;

  ${breakpoints.down(`md`)} {
    margin-right: 0.8rem;
    height: 0.8rem;
    width: 0.8rem;
  }
`;

export function getChipColor(status: ExperienceStatus) {
  if (status === ExperienceStatus.DRAFT) return `#FFA800`;
  if (status === ExperienceStatus.ARCHIVED) return `#ED6B6B`;
  if (status === ExperienceStatus.PAUSED) return `rgb(138, 141, 150)`;
  if (status === ExperienceStatus.SCHEDULED) return `#46ADFF`;
  return `#0adf73`;
}

export function getApprovalColor(status: ExperienceApprovalStatus) {
  if (status === ExperienceApprovalStatus.NOT_APPROVED_APPROVAL)
    return `#ED6B6B`;
  return `#8ABEFF`;
}
